angular.module('smartorg.r6.mgmts.calcEngineLog', []);
require('./calculation-engine-log-directive');
require('../../css/app.css');
module.exports = 'smartorg.r6.mgmts.calcEngineLog';
//# sourceMappingURL=app.js.map


// WEBPACK FOOTER //
// ./app/widgets/management/calculation-engine-log/app/js/plumbing/app.js